/**
 * The model the web engine runs, by WebLLM's ids in `prebuiltAppConfig` (@mlc-ai/web-llm 0.2.86): Qwen3.5-2B
 * (Apache-2.0), in two builds: `f16` needs the GPU's "shader-f16" feature, `f32` runs on any WebGPU; the weights are
 * 4-bit in both. One model, not tiers: on the intent eval the 0.8B added nothing to the embedding router (ADR 0042)
 * that every phone can carry, while the 2B added 16 points (docs/gigsync/model-comparison.md).
 */
export const Variant = { f16: "f16", f32: "f32" };
/** The GPU feature the f16 builds need. */
export const SHADER_F16 = "shader-f16";
export const MODEL = {
    name: "Qwen3.5-2B",
    ids: { f16: "Qwen3.5-2B-q4f16_1-MLC", f32: "Qwen3.5-2B-q4f32_1-MLC" },
    // 1,032 MB in 31 shards, plus library and tokenizer; about 2.2 GB of GPU memory, so only phones that say 8 GB.
    downloadMb: 1050,
    minMemoryGb: 8,
    // embed_tokens.q_weight: 248,320 × 256 uint32, past WebGPU's promised 128 MiB.
    largestTensorBytes: 254_279_680,
    thinks: true,
};
/** Every id this app may have put in the browser's cache, for removing them all. */
export const ALL_IDS = Object.values(MODEL.ids);
export const infoOf = (spec, variant) => ({
    id: spec.ids[variant],
    name: spec.name,
    downloadMb: spec.downloadMb,
});
//# sourceMappingURL=catalog.js.map